import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "@culturehq/components";

const DropdownItem = ({ children, to, icon, onClick }) => (
  <li>
    <Link className="chq-nav--dropi" to={to} onClick={onClick}>
      {icon && <><Icon icon={icon} />{" "}</>}
      {children}
    </Link>
  </li>
);

export default DropdownItem;
